import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ConfirmDeleteUser',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class ConfirmDeleteUser extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
